import React from "react";
import { Tag } from "antd";
import { Award, ArrowRight } from "lucide-react";

const LessonScoreView = ({
  score,
  totalQuestions,
  earnedPoints,
  totalPoints,
  submitting,
  onProceed,
}) => {
  const displayScore = earnedPoints !== undefined ? earnedPoints : score;
  const displayTotal = totalPoints !== undefined ? totalPoints : totalQuestions;
  const percentage = Math.round((displayScore / (displayTotal || 1)) * 100);

  return (
    <div className="space-y-4 text-left">
      <div className="bg-white rounded-2xl p-6 sm:p-8 text-center flex flex-col items-center border border-gray-100 shadow-sm">
        <div className="w-12 h-12 rounded-xl bg-gray-900 text-white flex items-center justify-center mb-3.5 shadow-xs">
          <Award className="w-6 h-6 text-white" />
        </div>

        <h2 className="font-gilroyBold text-xl text-gray-900 mb-1">
          Training Quiz Completed!
        </h2>
        <p className="text-gray-600 text-[13px] mb-4">
          Here is your official assessment score:
        </p>

        <div className="w-full max-w-xs bg-gray-50 border border-gray-100 rounded-2xl p-4 shadow-xs space-y-2 mb-4">
          <div className="text-3xl font-gilroyBold text-gray-900">
            {displayScore} / {displayTotal} {earnedPoints !== undefined ? "Points" : ""}
          </div>
          <div className="text-[13px] font-gilroyBold text-gray-700">
            {percentage}% Passing Score
          </div>
          <span
            className={`inline-block font-gilroyBold text-xs px-2.5 py-1 rounded-full border ${
              percentage >= 60
                ? "bg-emerald-50 text-emerald-700 border-emerald-200/80"
                : "bg-yellow-50 text-yellow-800 border-yellow-200/80"
            }`}
          >
            {percentage >= 60 ? "Verified Assessment" : "Completed Training"}
          </span>
        </div>

        <p className="text-gray-600 text-[13px] max-w-md leading-relaxed mb-1">
          Great job! You have satisfied the video training and quiz requirements. Click below to proceed to the final onboarding steps.
        </p>
      </div>

      <button
        type="button"
        disabled={submitting}
        onClick={onProceed}
        className="w-full py-3 px-4 bg-emerald-600 hover:bg-emerald-700 text-white font-gilroyBold text-[13px] rounded-xl border-0 shadow-xs cursor-pointer transition flex items-center justify-center gap-2"
      >
        <span>{submitting ? "Submitting..." : "Complete & Continue"}</span>
        <ArrowRight className="w-4 h-4" />
      </button>
    </div>
  );
};

export default LessonScoreView;
